// import {
//   ActionIcon,
//   Box,
//   Button,
//   Card,
//   Center,
//   CheckIcon,
//   Container,
//   Divider,
//   Flex,
//   Grid,
//   Group,
//   Loader,
//   NumberInput,
//   Paper,
//   Radio,
//   SimpleGrid,
//   Skeleton,
//   Slider,
//   Text,
//   TextInput,
//   UnstyledButton,
// } from "@mantine/core";

// import { usePlaidLink } from "react-plaid-link";

// import { IconChevronLeft, IconMinus, IconPlus } from "@tabler/icons-react";
// import { useState } from "react";
// import { useSelector } from "react-redux";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { useStyles } from "./style";

// import { DateInput } from "@mantine/dates";
// import { useForm } from "@mantine/form";
// import { useEffect } from "react";
// import { io } from "socket.io-client";
// import swal from "sweetalert";
// import { baseURL, socketURL } from "../../http";
// import {
//   connectCard,
//   deleteCustomer,
//   exchangeToken,
//   getConnectedAccounts,
//   getPlaidLink,
//   updateCard,
// } from "../../services/payment";
// import { getProfile } from "../../services/profile";
// import {
//   calTaxCustomPlan,
//   createSubscription,
//   selectPlan,
// } from "../../services/subscription";
// import { getCookie, removeCookie } from "../../utils";
// import { pageInfoAnalytics } from "../../config/mixpanelConfig";
// import { CiCreditCard1 } from "react-icons/ci";
// import { FaMinus, FaPlus } from "react-icons/fa6";
// const PaymentInfoNew = () => {
//   const [value, setValue] = useState("manual");

//   // const socket = io(baseURL);
//   const socket = io(socketURL);
//   const navigate = useNavigate();
//   const { state, search } = useLocation();
//   const queryParams = new URLSearchParams(search);
//   const newConnect = queryParams.get("connect");
//   const { profile } = useSelector((state) => state.profile);
//   const isTrialNotUsed = !profile?.user?.isTrialUsed;
//   const { classes } = useStyles();
//   const location = useLocation();
//   const isFreeAccount = location?.state?.isFreeAccount === true;
//   const taxDetails = location?.state?.taxDetails || false;
//   const susbcriptionType = location?.state?.subscriptionType;


//   const [sessionLink, setSessionLink] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [loadingCalculation, setLoadingCalculation] = useState(false);
//   const [paymentLoading, setPaymentLoading] = useState(false);
//   const [paymentDeductionLoading, setPaymentDeductionLoading] = useState(false);
//   const [paymentDeduction, setPaymentDeduction] = useState(false);
//   let item = state?.plan;
//   let monthlyPlan = state?.monthlyPlan;
//   let yearlyPlan = state?.yearlyPlan;
//   const [paymentDeductionFeedback, setPaymentDeductionFeedback] = useState("");
//   const [instance, setInstance] = useState(null);
//   const [connected, setConnected] = useState([]);
//   const [connectingCard, setConnectingCard] = useState(false);
//   const [updatecard, setUpdatecard] = useState(false);
//   const [selectedPkg, setSelectedPkg] = useState(item || "");
//   const [planResponse, setPlanResponse] = useState();
//   // const [calTaxAddOn, setCalTaxAddOn] = useState();
//   const [couponCodeValue, setCouponCodeValue] = useState("");
//   const [couponLoading, setCouponLoading] = useState(false);
//   const [couponMsg, setCouponMsg] = useState("");
//   const minimumClients = Number(selectedPkg?.patient) || 0;
//   const minimumStaff = Number(selectedPkg?.staff) || 0;
//   const [additionalStaffValue, setAdditionalStaffValue] =
//     useState(minimumStaff);
//   const [additionalClientValue, setAdditionalClientValue] =
//     useState(minimumClients);
//   let string =
//     newConnect == "true"
//       ? "This account is currently being used."
//       : `${selectedPkg?.staff} Staff Members, ${selectedPkg?.facility} Facility, ${selectedPkg?.patient} Patients & ${selectedPkg?.dailyUpdates} Daily Updates`;

//   // loading when fetching connected accounts
//   const [connectedLoading, setConnectedLoading] = useState(true);

//   // un comment to use delete account functionality.
//   // const [deleteAccountLoading, setDeleteAccountLoading] = useState(false);
//   useEffect(() => {
//     setAdditionalClientValue(minimumClients);
//     setAdditionalStaffValue(minimumStaff);
//   }, [selectedPkg]);

//   const handleSelectPkg = async (pkg, type) => {
//     setLoadingCalculation(true);
//     setSelectedPkg(pkg);
//     const resp = await selectPlan({ id: pkg?.id, billingType: type });
//     if (resp?.status === 200) {
//       setPlanResponse(resp?.data?.taxDetails);
//       setLoadingCalculation(false);
//     }
//   };
//   const card = connected?.find((v) => v?.creditCard);

//   const form = useForm({
//     initialValues: {
//       // nameCard: "",
//       // cardNumber: "",
//       // cardExp: "",
//       // CVV: "",
//       nameCard: "",
//       cardNumber: "",
//       cardExp: null,
//       cardMonth: null,
//       cardYear: null,
//       CVV: "",
//     },
//     validate: {
//       nameCard: (value) => (value ? null : "Please add card name"),
//       cardNumber: (value) =>
//         value && value?.length <= 16 ? null : "Please add a valid card number",
//       // cardExp: (value) => (value ? null : "Select expiry date"),
//       cardMonth: (value) => {
//         const isValidLength = value && value.length === 2;
//         return isValidLength ? null : "Please add a valid month";
//       },
//       cardYear: (value) => {
//         const isValidLength = value && value.length === 2;
//         return isValidLength ? null : "Please add a valid year";
//       },
//       CVV: (value) => {
//         const isValidLength =
//           value && (value?.length === 3 || value?.length === 4);
//         return isValidLength ? null : "Please add a valid number";
//       },
//     },
//   });

//   const config = {
//     onSuccess: async (public_token, metadata) => {
//       let bankData = await exchangeToken({ publicToken: public_token });
//       if (bankData) {
//         if (newConnect === "true") return navigate("/home/settings");
//         getAllConnected();
//       }
//     },
//     onExit: (err, metadata) => {
//     },
//     onEvent: (eventName, metadata) => {
//       if (eventName.includes("EXIT")) {
//         setLoading(false);
//       }
//     },
//     token: sessionLink,
//   };
//   const { open, exit, ready } = usePlaidLink(config);

//   useEffect(() => {
//     if (getCookie("token") && profile) {
//       socket.emit("join", profile?.user.id);
//       setInstance(socket);
//     }
//   }, [getCookie("token")]);

//   useEffect(() => {
//     socket.on("reconnect", () => {
//       if (profile?.user) {
//         socket.emit("join", profile?.user?.id);
//       }
//     });

//     socket.on("payment-update", (status) => {
//       if (status === "payment succeeded") {
//         setPaymentDeductionLoading(false);
//         setPaymentDeduction(false);
//         getProfile();
//         if (!location.pathname.includes("home/settings"))
//           swal("Subscription Completed!", {
//             icon: "success",
//             buttons: {
//               // ok: "Proceed to Dashboard"
//               ok: {
//                 text: "Proceed to Dashboard",
//                 value: "dashboard", // Assign a unique value to identify the button
//               },
//             },
//           }).then((value) => {
//             switch (value) {
//               default:
//                 navigate("/home");
//             }
//           });
//         else
//           swal("Account changed Successfully", {
//             icon: "success",
//             buttons: {
//               ok: "Ok",
//             },
//           });
//       } else if (status?.code === "payment failed") {
//         swal("Payment Failed", {
//           icon: "error",
//           text: `${status?.message}\nPlease ensure your card has enough balance.`,
//           buttons: {
//             ok: {
//               text: "Go Back",
//               value: "dashboard",
//             },
//           },
//         }).then((value) => {
//           switch (value) {
//             case "dashboard":
//               removeCookie("token");
//               navigate("/");
//             default:
//               navigate("/home");
//           }
//         });
//       } else {
//         setPaymentDeductionLoading(false);
//         setPaymentDeductionFeedback(status);
//       }
//     });
//   }, []);

//   useEffect(() => {
//     // getLink();
//     getAllConnected();
//     pageInfoAnalytics("Payment Page Viewed", "Payment Page");
//   }, []);

//   useEffect(() => {
//     if (ready) {
//       setLoading(false);
//     }
//   }, [ready, sessionLink]);

//   useEffect(() => {
//     if (form.getInputProps("cardNumber")?.value?.length > 16) {
//       form.setFieldValue(
//         "cardNumber",
//         form.getInputProps("cardNumber")?.value?.slice(0, 16)
//       );
//     }
//   }, [form.getInputProps("cardNumber")?.value]);

//   useEffect(() => {
//     if (form.getInputProps("CVV")?.value?.length > 4) {
//       form.setFieldValue("CVV", form.getInputProps("CVV")?.value?.slice(0, 4));
//     }
//   }, [form.getInputProps("CVV")?.value]);

//   useEffect(() => {
//     if (form.getInputProps("cardMonth")?.value?.length > 2) {
//       form.setFieldValue(
//         "cardMonth",
//         form.getInputProps("cardMonth")?.value?.slice(0, 2)
//       );
//     }
//   }, [form.getInputProps("cardMonth")]);

//   useEffect(() => {
//     if (form.getInputProps("cardYear")?.value?.length > 2) {
//       form.setFieldValue(
//         "cardYear",
//         form.getInputProps("cardYear")?.value?.slice(0, 2)
//       );
//     }
//   }, [form.getInputProps("cardYear")]);

//   const getAllConnected = async () => {
//     let accounts = await getConnectedAccounts();
//     const activeAccounts = accounts.filter((account) => account.isActive);
//     setConnected(activeAccounts);
//     setConnectedLoading(false);
//   };

//   const getLink = async () => {
//     let data = await getPlaidLink();
//     setSessionLink(data?.link_token);
//   };
//   const onFinish = async (values) => {
//     const { cardMonth, cardYear } = values;
//     let obj = {
//       ...values,
//       packageId: selectedPkg?.id,
//       stripePlanId: selectedPkg?.stripeId,
//       email: profile?.user?.email,
//       userId: profile?.user.id,
//       businessId: profile?.business?.id,
//       cardExp: `${cardMonth}/${cardYear}`,
//       userId: profile?.user.id,
//     };

//     delete obj?.cardMonth;
//     delete obj?.cardYear;

//     setConnectingCard(true);
//     let accounts = await getConnectedAccounts();
//     if (accounts?.length > 0) {
//       updateCard(obj, (error, data) => {
//         if (!error) {
//           // setPlanResponse("");
//           setConnectingCard(false);
//           if (newConnect === "true") return navigate("/home/settings");
//           getAllConnected();
//           setUpdatecard(false);
//         } else {
//           setConnectingCard(false);
//         }
//       });
//     } else {
//       connectCard(obj, (error, data) => {
//         if (!error) {
//           // setPlanResponse("");
//           setConnectingCard(false);
//           if (newConnect === "true") return navigate("/home/settings");
//           getAllConnected();
//         } else {
//           setConnectingCard(false);
//         }
//       });
//     }
//   };
//   const onBack = () => {
//     navigate("/selectprice");
//     setPlanResponse("");
//   };

//   const start = () => {
//     open();
//     setLoading(true);
//   };
//   const removeAccount = async (paymentMethod) => {
//     if (!paymentMethod?.isActive) {
//       // setDeleteAccountLoading(true);
//       let response = await deleteCustomer(paymentMethod?.stripeCustomerId);
//       if (response) {
//         getAllConnected();
//         // setDeleteAccountLoading(false);
//         setPaymentLoading(false);
//       }
//     } else {
//       swal({
//         title: "Remove Account",
//         text: "Cannot remove account, this account is being used.",
//         icon: "warning",
//       });
//     }
//   };

//   const payNow = async (paymentMethod) => {
//     setPaymentLoading(true);
//     let payload = {};
//     let obj = {
//       packageId: selectedPkg?.id,
//       stripePlanId: selectedPkg?.stripeId,
//       email: profile?.user?.email,
//       userId: profile?.user.id,
//       businessId: profile?.business?.id,
//       stripeCustomerId: paymentMethod?.stripeCustomerId,
//       susbcriptionType: selectedPkg?.duration,
//     };
//     if (
//       Number(item?.staff) !== additionalStaffValue ||
//       Number(item?.patient) !== additionalClientValue
//     ) {
//       payload = {
//         ...obj,
//         isUserChangeAdditionalCount: true,
//         customStaffCount: String(additionalStaffValue),
//         customPatientCount: String(additionalClientValue),
//         total: planResponse?.subtotal
//           ? planResponse.subtotal
//           : totalPrice.toFixed(2),
//       };
//     } else {
//       payload = obj;
//     }
//     const resp = await createSubscription(payload, null, "automatic");
//     if (resp?.status === 200) {
//       setPlanResponse("");
//       setPaymentLoading(false);
//       setPaymentDeduction(true);
//       setPaymentDeductionLoading(true);
//     }
//   };
//   const names = {
//     Personal: "Silver",
//     Agency: "Gold",
//     Trial: "Trial",
//   };

//   const staffUnitCost =
//     Number(profile?.user?.additionalStaffCost) ||
//     Number(selectedPkg?.additionalStaff) ||
//     0;

//   const clientUnitCost =
//     Number(profile?.user?.additionalClientCost) ||
//     Number(selectedPkg?.additionalClient) ||
//     0;
//   const extraStaff = Math.max(0, additionalStaffValue - minimumStaff);
//   const extraClient = Math.max(0, additionalClientValue - minimumClients);
//   const addOnStaffPrice = extraStaff * staffUnitCost;
//   const addOnClientPrice = extraClient * clientUnitCost;

//   // Subtotal = Plan price + add-on price
//   const basePlanPrice = Number((planResponse ?? taxDetails)?.subtotal || 0);
//   const totalPrice = basePlanPrice + addOnStaffPrice + addOnClientPrice;

//   // Tax = % of Subtotal (including add-ons)
//   const taxPercentage = Number(
//     (planResponse ?? taxDetails)?.taxPercentage || 0
//   );
//   const calculatedTaxAmount = (totalPrice * taxPercentage) / 100;

//     currency: (planResponse ?? taxDetails)?.currency || "USD",
//     subtotal: totalPrice.toFixed(2),
//     taxAmount: calculatedTaxAmount.toFixed(2),
//     taxJurisdiction: (planResponse ?? taxDetails)?.taxJurisdiction || "",
//     taxPercentage: taxPercentage,
//     total: (totalPrice + calculatedTaxAmount).toFixed(2),
//   });

//   const totalPriceWithTax = totalPrice + calculatedTaxAmount;

//   // const totalPrice =
//   //   (Number(planResponse?.subtotal || 0) ?? Number(taxDetails?.subtotal || 0)) +
//   //   addOnStaffPrice +
//   //   addOnClientPrice;

//   // const totalPrice =
//   //   Number((planResponse ?? taxDetails)?.subtotal || 0) +
//   //   addOnStaffPrice +
//   //   addOnClientPrice;

//   // const totalPriceWithTax =
//   //   (planResponse
//   //     ? Number(planResponse.subtotal || 0) + Number(planResponse.taxAmount || 0)
//   //     : Number(taxDetails?.subtotal || 0) +
//   //       Number(taxDetails?.taxAmount || 0)) +
//   //   addOnStaffPrice +
//   //   addOnClientPrice;

//   // const totalPriceWithTax =
//   //   (Number(planResponse?.subtotal || 0) ?? Number(taxDetails?.subtotal || 0)) +
//   //   addOnStaffPrice +
//   //   addOnClientPrice +
//   //   (Number(planResponse?.taxAmount) ?? Number(taxDetails?.taxAmount));

//   // const handleAddOn = async () => {
//   //   setLoadingCalculation(true);
//   //   const resp = await calTaxCustomPlan({
//   //     total: totalPrice.toFixed(2),
//   //     addOnStaffPrice: addOnStaffPrice,
//   //     addOnClientPrice: addOnClientPrice,
//   //   });
//   //   if (resp?.status === 200) {
//   //     setCalTaxAddOn(resp?.data?.taxDetails);
//   //     setLoadingCalculation(false);
//   //   }
//   // };
//   return (
//     <div className="payment-page">
//       {/* <Container size={"sm"}> */}
//       {/* <Radio.Group value={value} onChange={setValue} size="md" name="paytype">
//           <SimpleGrid cols={2} spacing={10}>
//             <Radio
//               className={
//                 value === "automatic" ? classes.selected : classes.type
//               }
//               value="automatic"
//               size="md"
//               color="yellow"
//               label={
//                 <>
//                   <Text className={classes.font1}> Automatic</Text>{" "}
//                   <Text className={classes.font2}>
//                     Connect to bank with plaid
//                   </Text>
//                 </>
//               }
//             />
//             <Radio
//               className={value === "manual" ? classes.selected : classes.type}
//               size="md"
//               color="yellow"
//               value="manual"
//               label={
//                 <>
//                   <Text className={classes.font1}>Manual</Text>{" "}
//                   <Text className={classes.font2}>
//                     Enter card Details Manually
//                   </Text>
//                 </>
//               }
//             />
//           </SimpleGrid>
//         </Radio.Group> */}
//       {/* </Container> */}

//       {/* plaid link component */}
//       {value === "automatic" && (
//         <>
//           {!isFreeAccount && (
//             <Group className={classes.back}>
//               <ActionIcon
//                 variant="outline"
//                 size={"xl"}
//                 radius={"xl"}
//                 onClick={onBack}
//               >
//                 <IconChevronLeft />
//               </ActionIcon>
//               <Text>Back</Text>
//             </Group>
//           )}
//           <Container className={classes.centered} size={"sm"}>
//             <div className={classes.logo}>
//               <img width={"30%"} src="assets/images/logo2.png" alt="" />
//             </div>
//             <Text className={classes.title}>Payment Information</Text>
//           </Container>
//           <center style={{ marginTop: "50px" }}>
//             <Flex
//               mih={50}
//               gap="md"
//               justify="flex-start"
//               // align="center"
//               direction="row"
//               wrap="wrap"
//               className={classes.plaidComponent}
//             >
//               <img
//                 className={classes.connectBankImage}
//                 src="assets/images/bank.png"
//                 alt=""
//               />
//               <Flex
//                 direction="column"
//                 align={"flex-start"}
//                 className={classes.insideFlex}
//               >
//                 {connectedLoading ? (
//                   <>
//                     <Skeleton
//                       height={50}
//                       width={100}
//                       radius="sm"
//                       style={{ marginTop: "10px" }}
//                     />
//                     <Skeleton
//                       height={50}
//                       radius="sm"
//                       style={{ marginTop: "10px" }}
//                     />
//                   </>
//                 ) : connected?.filter((v) => !v?.creditCard)?.length ? (
//                   paymentDeduction ? (
//                     <div>
//                       <Flex direction="row" align={"center"} gap={10}>
//                         {paymentDeductionLoading && (
//                           <Loader color="yellow" size={"sm"} />
//                         )}
//                         <Text
//                           my={10}
//                           style={{
//                             fontWeight: "600",
//                             textAlign: "start",
//                           }}
//                           color={"yellow"}
//                         >
//                           {paymentDeductionFeedback
//                             ? ""
//                             : "Processing Payment ..."}
//                         </Text>
//                       </Flex>
//                       <Text
//                         my={10}
//                         style={{
//                           fontWeight: "600",
//                           textAlign: "start",
//                           opacity: 0.3,
//                         }}
//                       >
//                         {paymentDeductionFeedback
//                           ? paymentDeductionFeedback
//                           : "Please wait we are tranfering funds..."}
//                       </Text>
//                     </div>
//                   ) : (
//                     <div>
//                       <Text
//                         my={10}
//                         style={{
//                           fontWeight: "600",
//                           textAlign: "start",
//                         }}
//                         color="green"
//                       >
//                         Connected Bank Account
//                       </Text>

//                       <p
//                         style={{
//                           textAlign: "start",
//                           fontWeight: "bold",
//                           margin: 0,
//                           padding: 0,
//                         }}
//                       >
//                         {/* {names[state?.plan?.name]}{" "} */}
//                         {selectedPkg?.name}{" "}
//                         {newConnect != "true" ? `($${selectedPkg?.cost})` : ""}
//                       </p>
//                       <p
//                         style={{
//                           color: "#A8A8A8",
//                           textAlign: "start",
//                         }}
//                       >
//                         {string}
//                       </p>

//                       {newConnect != "true" &&
//                         !connected?.find((v) => !v?.creditCard)?.isActive && (
//                           <Flex direction="row" gap={20}>
//                             <Button
//                               color="yellow"
//                               onClick={() =>
//                                 payNow(connected?.find((v) => !v?.creditCard))
//                               }
//                               loading={paymentLoading}
//                             >
//                               Subscribe Now
//                             </Button>

//                             {/* <Button
//                             variant="outline"
//                             color="yellow"
//                             loading={deleteAccountLoading}
//                             onClick={() =>
//                               removeAccount(
//                                 connected?.find((v) => !v?.creditCard)
//                               )
//                             }
//                           >
//                             Remove
//                           </Button> */}
//                           </Flex>
//                         )}
//                     </div>
//                   )
//                 ) : (
//                   <div>
//                     <Text
//                       my={10}
//                       style={{ fontWeight: "600", textAlign: "start" }}
//                     >
//                       Connect Bank Account
//                     </Text>
//                     <Text variant="text" style={{ textAlign: "start" }}>
//                       Link your bank account for smooth transaction.
//                     </Text>

//                     <p
//                       style={{
//                         textAlign: "start",
//                         fontWeight: "bold",
//                         margin: 0,
//                         padding: 0,
//                       }}
//                     >
//                       {selectedPkg?.name}{" "}
//                       {newConnect != "true" ? `($${selectedPkg?.cost})` : ""}
//                     </p>
//                     <p
//                       style={{
//                         color: "#A8A8A8",
//                         textAlign: "start",
//                         margin: 0,
//                       }}
//                     >
//                       <br />
//                       {string}
//                     </p>
//                     <Flex justify={"flex-start"} my={10}>
//                       <Button color="yellow" onClick={start} loading={loading}>
//                         Connect
//                       </Button>
//                     </Flex>
//                   </div>
//                 )}
//               </Flex>
//             </Flex>
//           </center>
//         </>
//       )}
//       {value === "manual" && (
//         <>
//           {connectedLoading ? (
//             <>
//               {!isFreeAccount && (
//                 <Group className={classes.back}>
//                   <ActionIcon
//                     variant="outline"
//                     size={"xl"}
//                     radius={"xl"}
//                     onClick={onBack}
//                   >
//                     <IconChevronLeft />
//                   </ActionIcon>
//                   <Text>Back</Text>
//                 </Group>
//               )}
//               {/* <Container className={classes.centered} mih={"100vh"} size={"sm"}> */}
//               {/* <div className={classes.logo}>
//                   <img width={"30%"} src="assets/images/logo2.png" alt="" />
//                 </div>
//                 <Text className={classes.title}>Payment Information</Text> */}
//               <Center w="100%" mih="100vh">
//                 <Loader color="yellow" />
//               </Center>
//               {/* </Container> */}
//             </>
//           ) : connected?.filter((v) => v?.creditCard)?.length ? (
//             <>
//               {!isFreeAccount && (
//                 <Group className={classes.back}>
//                   <ActionIcon
//                     variant="outline"
//                     size={"xl"}
//                     radius={"xl"}
//                     onClick={onBack}
//                   >
//                     <IconChevronLeft />
//                   </ActionIcon>
//                   <Text>Back</Text>
//                 </Group>
//               )}
//               <Container className={classes.centered} size={"sm"}>
//                 <div className={classes.logo}>
//                   <img width={"30%"} src="assets/images/logo2.png" alt="" />
//                 </div>
//                 <Text className={classes.title}>Payment Information</Text>
//               </Container>
//               <Container size={"md"}>
//                 <Card shadow="sm" className={classes.card}>
//                   <Flex
//                     // mih={50}s
//                     gap="md"
//                     justify="flex-start"
//                     direction="row"
//                     wrap="wrap"
//                     // className={classes.plaidComponent}
//                   >
//                     <img
//                       className={classes.connectBankImage}
//                       src="assets/images/bank.png"
//                       alt=""
//                     />
//                     {paymentDeduction ? (
//                       <div>
//                         <Flex direction="row" align={"center"} gap={10}>
//                           {paymentDeductionLoading && (
//                             <Loader color="yellow" size={"sm"} />
//                           )}
//                           <Text
//                             my={10}
//                             style={{
//                               fontWeight: "600",
//                               textAlign: "start",
//                             }}
//                             color={"yellow"}
//                           >
//                             {paymentDeductionFeedback
//                               ? ""
//                               : "Processing Payment ..."}
//                           </Text>
//                         </Flex>
//                         <Text
//                           my={10}
//                           style={{
//                             fontWeight: "600",
//                             textAlign: "start",
//                             opacity: 0.3,
//                           }}
//                         >
//                           {paymentDeductionFeedback
//                             ? paymentDeductionFeedback
//                             : "Please wait we are tranfering funds..."}
//                         </Text>
//                       </div>
//                     ) : (
//                       <div>
//                         <Text
//                           my={10}
//                           style={{
//                             fontWeight: "600",
//                             textAlign: "start",
//                           }}
//                           color="green"
//                         >
//                           Connected Card
//                         </Text>
//                         <p style={{ color: "#A8A8A8", textAlign: "start" }}>
//                           Details
//                         </p>
//                         <table>
//                           <tr>
//                             <td>Account Name: </td>
//                             <td>{card?.cardName}</td>
//                           </tr>
//                           <tr>
//                             <td> Card Number : </td>
//                             <td>{card?.cardNumber}</td>
//                           </tr>
//                         </table>
//                         {newConnect !== "true" &&
//                           !connected?.filter((v) => v?.creditCard)
//                             ?.isActive && (
//                             <Flex mt={30} direction="row" gap={20}>
//                               <Button
//                                 color="yellow"
//                                 onClick={() =>
//                                   payNow(connected?.find((v) => v?.creditCard))
//                                 }
//                                 loading={paymentLoading}
//                               >
//                                 Subscribe Now
//                               </Button>
//                               <Button
//                                 color="yellow"
//                                 onClick={() => {
//                                   setConnected([]);
//                                   setUpdatecard(true);

//                                   // newConnect='true'
//                                 }}

//                                 // loading={paymentLoading}
//                               >
//                                 Update Card
//                               </Button>

//                               {/* <Button
//                             variant="outline"
//                             color="yellow"
//                             loading={deleteAccountLoading}
//                             onClick={() =>
//                               removeAccount(
//                                 connected?.find((v) => v?.creditCard)
//                               )
//                             }
//                           >
//                             Remove
//                           </Button> */}
//                             </Flex>
//                           )}
//                       </div>
//                     )}
//                   </Flex>
//                 </Card>
//               </Container>
//             </>
//           ) : (
//             <Flex className={classes.paymentPageBox}>
//               <Box className={classes.paymentPageBoxLeft}>
//                 <Box className={classes.paymentPageBoxLeftInner}>
//                   {!isFreeAccount && (
//                     <UnstyledButton
//                       onClick={onBack}
//                       className={classes.paymentPageBoxBackBtn}
//                     >
//                       <IconChevronLeft />
//                       Back
//                     </UnstyledButton>
//                   )}
//                   <img
//                     src="assets/images/logo2.png"
//                     alt=""
//                     className={classes.paymentPageBoxLogo}
//                   />
//                   <Box className={classes.paymentLeftContent}>
//                     <h5 className="hdng">Payment Summary</h5>
//                     <p className="subHdng">
//                       Get {yearlyPlan ? yearlyPlan?.promotion : ""}% off when
//                       you subscribe annually
//                     </p>
//                     <p className="trialPkgNameText">
//                       {isTrialNotUsed ? (
//                         <>
//                           <p className="trialText">2 Weeks free trial</p>&nbsp;(
//                           {selectedPkg?.name} Plan)
//                         </>
//                       ) : (
//                         `(${selectedPkg?.name} Plan)`
//                       )}
//                     </p>
//                     {monthlyPlan && (
//                       <Flex
//                         className={`${classes.pkgSelectBox} ${
//                           selectedPkg?.id === monthlyPlan?.id
//                             ? classes.selectedPkgSelectBox
//                             : ""
//                         }`}
//                         onClick={() => handleSelectPkg(monthlyPlan, "month")}
//                       >
//                         <Radio
//                           icon={CheckIcon}
//                           className="radioBtn"
//                           checked={selectedPkg?.id === monthlyPlan?.id}
//                         />
//                         <Box className="pkgInfo">
//                           <p className="pkgDurationText">Monthly</p>
//                           <p className="pkgPrice">
//                             ${monthlyPlan?.cost} / {monthlyPlan?.duration}
//                             <span className="staffAndClientCount">
//                               ({monthlyPlan?.staff} Staff,
//                               {monthlyPlan?.patient} Clients)
//                             </span>
//                           </p>
//                         </Box>
//                       </Flex>
//                     )}
//                     {yearlyPlan && (
//                       <Flex
//                         className={`${classes.pkgSelectBox} ${
//                           selectedPkg?.id === yearlyPlan?.id
//                             ? classes.selectedPkgSelectBox
//                             : ""
//                         }`}
//                         onClick={() => handleSelectPkg(yearlyPlan, "year")}
//                       >
//                         <Radio
//                           icon={CheckIcon}
//                           className="radioBtn"
//                           checked={selectedPkg?.id === yearlyPlan?.id}
//                         />
//                         <Box className="pkgInfo">
//                           <p className="pkgDurationText">Annual</p>
//                           <p className="pkgPrice">
//                             ${yearlyPlan?.cost} / {yearlyPlan?.duration}
//                             <span className="staffAndClientCount">
//                               ({yearlyPlan?.staff} Staff, {yearlyPlan?.patient}{" "}
//                               Clients)
//                             </span>
//                           </p>
//                         </Box>
//                         <p className="savePer">Save {yearlyPlan?.promotion}%</p>
//                       </Flex>
//                     )}
//                     {item?.name !== "Starter" && (
//                       <>
//                         <p className={classes.staffAndClientAddSecHdng}>
//                           Subscription Add-on
//                         </p>
//                         <p className={classes.staffAndClientAddSecSubHdng}>
//                           Get 20% off if you add more Staff or Clients to your
//                           subscription
//                         </p>
//                         <Box className={classes.staffAndClientCountBox}>
//                           <NumberInput
//                             className={classes.outcomeNumberInput}
//                             label="Staff"
//                             type="number"
//                             min={minimumStaff}
//                             variant="filled"
//                             value={additionalStaffValue}
//                             onChange={(e) => {
//                               const newValue = parseInt(e.target.value) || 0;
//                               setAdditionalStaffValue(newValue);
//                             }}
//                             icon={
//                               <ActionIcon
//                                 className={classes.inc_dec_Btn}
//                                 size="xs"
//                                 onClick={() =>
//                                   setAdditionalStaffValue((prev) =>
//                                     Math.max(minimumStaff, prev - 1)
//                                   )
//                                 }
//                               >
//                                 <FaMinus size={15} color="#000" />
//                               </ActionIcon>
//                             }
//                             rightSection={
//                               <ActionIcon
//                                 className={classes.inc_dec_Btn}
//                                 size="xs"
//                                 onClick={() =>
//                                   setAdditionalStaffValue((prev) => prev + 1)
//                                 }
//                               >
//                                 <FaPlus size={15} color="#000" />
//                               </ActionIcon>
//                             }
//                           />
//                           <NumberInput
//                             className={classes.outcomeNumberInput}
//                             label="Client"
//                             type="number"
//                             min={minimumClients}
//                             variant="filled"
//                             value={additionalClientValue}
//                             onChange={(e) => {
//                               const newValue = parseInt(e.target.value) || 0;
//                               setAdditionalClientValue(newValue);
//                             }}
//                             icon={
//                               <ActionIcon
//                                 className={classes.inc_dec_Btn}
//                                 size="xs"
//                                 onClick={() =>
//                                   setAdditionalClientValue((prev) =>
//                                     Math.max(minimumClients, prev - 1)
//                                   )
//                                 }
//                               >
//                                 <FaMinus size={15} color="#000" />
//                               </ActionIcon>
//                             }
//                             rightSection={
//                               <ActionIcon
//                                 className={classes.inc_dec_Btn}
//                                 size="xs"
//                                 onClick={() =>
//                                   setAdditionalClientValue((prev) => prev + 1)
//                                 }
//                               >
//                                 <FaPlus size={15} color="#000" />
//                               </ActionIcon>
//                             }
//                           />
//                         </Box>
//                       </>
//                     )}

//                     {/* <Button
//                       className={[
//                         classes.paymentBtn,
//                         classes.couponCodeSubmitBtn,
//                       ]}
//                       onClick={() => handleAddOn()}
//                     >
//                       Add On
//                     </Button> */}

//                     <Flex gap={15} my={20}>
//                       <Box className={classes.couponCodeInput}>
//                         <TextInput
//                           placeholder="Coupon Code"
//                           className={classes.paymentInputFieldStyle}
//                           value={couponCodeValue}
//                           onChange={(e) => {
//                             setCouponCodeValue(e.target.value);
//                             setCouponMsg("");
//                           }}
//                         />
//                         {couponMsg && (
//                           <p className={classes.validationErrorMsg}>
//                             {couponMsg}
//                           </p>
//                         )}
//                       </Box>
//                       <Button
//                         className={[
//                           classes.paymentBtn,
//                           classes.couponCodeSubmitBtn,
//                         ]}
//                         disabled={!couponCodeValue?.trim() || couponLoading}
//                         loading={couponLoading}
//                         onClick={() => {
//                           setCouponLoading(true);
//                           setTimeout(() => {
//                             setCouponMsg("Invalid Code");
//                             setCouponCodeValue("");
//                             setCouponLoading(false);
//                           }, 1000);
//                         }}
//                       >
//                         Apply
//                       </Button>
//                     </Flex>
//                     {loadingCalculation ? (
//                       <Flex justify="center" align="center" my={50}>
//                         <Loader color="yellow" />
//                       </Flex>
//                     ) : (
//                       <Box>
//                         <Flex className={classes.paymentPriceRow}>
//                           <p>Discount Applied</p>
//                           <Flex direction="column" align="flex-end" gap={10}>
//                             <p>-$0.00</p>
//                             {isTrialNotUsed && (
//                               <p className="trialText">Free Trial</p>
//                             )}
//                           </Flex>
//                         </Flex>
//                         <Divider mt={24} mb={24} />
//                         <Flex className={classes.paymentPriceRow}>
//                           <p>Subscription Plan</p>
//                           <p>
//                             $
//                             {planResponse?.subtotal
//                               ? planResponse?.subtotal
//                               : taxDetails?.subtotal}
//                           </p>
//                         </Flex>
//                         {item?.name !== "Starter" && (
//                           <>
//                             <Flex className={classes.paymentPriceRow}>
//                               <p>Add-on Staff</p>
//                               <p>${addOnStaffPrice.toFixed(2)}</p>
//                             </Flex>
//                             <Flex className={classes.paymentPriceRow}>
//                               <p>Add-on Client</p>
//                               <p>${addOnClientPrice.toFixed(2)}</p>
//                             </Flex>
//                           </>
//                         )}
//                         <Flex className={classes.paymentPriceRow}>
//                            <p>Tax</p>
//                           <p>${calculatedTaxAmount.toFixed(2)}</p>
//                         </Flex>
//                         <Flex className={classes.totalPriceRow}>
//                           <p>Total</p>
//                           <p>${totalPriceWithTax.toFixed(2)}</p>
//                         </Flex>
//                       </Box>
//                     )}
//                   </Box>
//                 </Box>
//               </Box>
//               <Box className={classes.paymentPageBoxRight}>
//                 <form onSubmit={form.onSubmit((values) => onFinish(values))}>
//                   <h4>
//                     <CiCreditCard1 size={34} />
//                     Credit or Debit Card
//                   </h4>
//                   <div className={classes.inputs}>
//                     <TextInput
//                       variant="filled"
//                       id="name-on-card"
//                       label="Name on Card"
//                       size="lg"
//                       type=""
//                       placeholder="Eg.abc"
//                       {...form.getInputProps("nameCard")}
//                       className={classes.paymentInputFieldStyle}
//                     />
//                   </div>

//                   <div className={classes.inputs}>
//                     <TextInput
//                       variant="filled"
//                       id="card-number"
//                       label="Card Number"
//                       size="lg"
//                       type="number"
//                       placeholder="Eg.5952 **** **** ****"
//                       {...form.getInputProps("cardNumber")}
//                       className={classes.paymentInputFieldStyle}
//                     />
//                     {form.errors.cardNumber && (
//                       <div style={{ color: "red" }}>
//                         {form.errors.cardNumber.message}
//                       </div>
//                     )}
//                   </div>

//                   {/* <SimpleGrid cols={2} className={classes.m10}>
//                   <DateInput
//                     variant="filled"
//                     id="expiry-date"
//                     label="Expiry Date"
//                     valueFormat="MM/YY"
//                     size="lg"
//                     minDate={new Date()}
//                     placeholder="Eg.08/23"
//                     {...form.getInputProps("cardExp")}
//                     className={classes.myfont}
//                   />
//                   <TextInput
//                     variant="filled"
//                     id="cvv"
//                     label="CVV"
//                     type="number"
//                     size="lg"
//                     placeholder="Eg.***"
//                     {...form.getInputProps("CVV")}
//                     className={classes.myfont}
//                   />
//                 </SimpleGrid> */}

//                   <Grid align="flex-end">
//                     <Grid.Col span={4}>
//                       {/* ----- card month ----- */}
//                       <TextInput
//                         size="lg"
//                         label="MM"
//                         type="number"
//                         variant="filled"
//                         placeholder="MM"
//                         className={classes.paymentInputFieldStyle}
//                         {...form.getInputProps("cardMonth")}
//                       />
//                     </Grid.Col>
//                     {/* ----- card year ----- */}
//                     <Grid.Col span={4}>
//                       <TextInput
//                         size="lg"
//                         label="YY"
//                         type="number"
//                         variant="filled"
//                         placeholder="YY"
//                         className={classes.paymentInputFieldStyle}
//                         {...form.getInputProps("cardYear")}
//                       />
//                     </Grid.Col>
//                     <Grid.Col span={4}>
//                       <TextInput
//                         size="lg"
//                         label="CVV"
//                         type="number"
//                         variant="filled"
//                         placeholder="Eg.***"
//                         className={classes.paymentInputFieldStyle}
//                         {...form.getInputProps("CVV")}
//                       />
//                     </Grid.Col>
//                   </Grid>

//                   <Button
//                     id="submit-card"
//                     type="submit"
//                     loading={connectingCard}
//                     className={classes.paymentBtn}
//                   >
//                     {isTrialNotUsed ? "Start Free Trial" : "Connect"}
//                   </Button>
//                   <p className={classes.agreeTermsCondText}>
//                     By subscribing, you agree to our{" "}
//                     <Link to="/term-conditions">terms and conditions</Link>.
//                   </p>
//                 </form>
//               </Box>
//             </Flex>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default PaymentInfoNew;

import {
  ActionIcon,
  Box,
  Button,
  Card,
  Center,
  CheckIcon,
  Container,
  Divider,
  Flex,
  Grid,
  Group,
  Loader,
  NumberInput,
  Paper,
  Radio,
  SimpleGrid,
  Skeleton,
  Slider,
  Text,
  TextInput,
  UnstyledButton,
} from "@mantine/core";

import { usePlaidLink } from "react-plaid-link";

import { IconChevronLeft, IconMinus, IconPlus } from "@tabler/icons-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useStyles } from "./style";

import { DateInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import { io } from "socket.io-client";
import swal from "sweetalert";
import { baseURL, socketURL } from "../../http";
import {
  connectCard,
  deleteCustomer,
  exchangeToken,
  getConnectedAccounts,
  getPlaidLink,
  updateCard,
} from "../../services/payment";
import { getProfile } from "../../services/profile";
import {
  calTaxCustomPlan,
  createSubscription,
  selectPlan,
} from "../../services/subscription";
import { validateDiscountCode } from "../../services/discountCode";
import { getCookie, removeCookie, showError, showInfo } from "../../utils";
import { pageInfoAnalytics } from "../../config/mixpanelConfig";
import { CiCreditCard1 } from "react-icons/ci";
import { FaMinus, FaPlus } from "react-icons/fa6";
const PaymentInfoNew = () => {
  // const [value, setValue] = useState("manual");

  // const socket = io(baseURL);
  const socket = io(socketURL);
  const navigate = useNavigate();
  const { state, search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const newConnect = queryParams.get("connect");
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  const isTrialNotUsed = !profile?.user?.isTrialUsed;
  const { classes } = useStyles();
  const location = useLocation();
  const isFreeAccount = location?.state?.isFreeAccount === true;
  const taxDetails = location?.state?.taxDetails || false;
  const susbcriptionType = location?.state?.subscriptionType;

  const [sessionLink, setSessionLink] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingCalculation, setLoadingCalculation] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentDeductionLoading, setPaymentDeductionLoading] = useState(false);
  const [paymentDeduction, setPaymentDeduction] = useState(false);
  let item = state?.plan;
  let monthlyPlan = state?.monthlyPlan;
  let yearlyPlan = state?.yearlyPlan;
  const [paymentDeductionFeedback, setPaymentDeductionFeedback] = useState("");
  const [instance, setInstance] = useState(null);
  const [connected, setConnected] = useState([]);
  const [connectingCard, setConnectingCard] = useState(false);
  const [paymentError, setPaymentError] = useState(false);
  const [updatecard, setUpdatecard] = useState(false);
  const [selectedPkg, setSelectedPkg] = useState(item || "");
  const [planResponse, setPlanResponse] = useState();
  // const [calTaxAddOn, setCalTaxAddOn] = useState();
  const [couponCodeValue, setCouponCodeValue] = useState("");
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponMsg, setCouponMsg] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(null);
  const minimumClients = Number(selectedPkg?.patient) || 0;
  const minimumStaff = Number(selectedPkg?.staff) || 0;
  const [additionalStaffValue, setAdditionalStaffValue] =
    useState(minimumStaff);
  const [additionalClientValue, setAdditionalClientValue] =
    useState(minimumClients);
  let string =
    newConnect == "true"
      ? "This account is currently being used."
      : `${selectedPkg?.staff} Staff Members, ${selectedPkg?.facility} Facility, ${selectedPkg?.patient} Patients & ${selectedPkg?.dailyUpdates} Daily Updates`;

  // loading when fetching connected accounts
  const [connectedLoading, setConnectedLoading] = useState(true);

  // un comment to use delete account functionality.
  // const [deleteAccountLoading, setDeleteAccountLoading] = useState(false);

  const staffUnitCost =
    Number(profile?.user?.additionalStaffCost) ||
    Number(selectedPkg?.additionalStaff) ||
    0;

  const clientUnitCost =
    Number(profile?.user?.additionalClientCost) ||
    Number(selectedPkg?.additionalClient) ||
    0;
  const extraStaff = Math.max(0, additionalStaffValue - minimumStaff);
  const extraClient = Math.max(0, additionalClientValue - minimumClients);
  const isAnnual = selectedPkg?.duration === 'year';
  const addOnStaffFull = extraStaff * staffUnitCost * (isAnnual ? 12 : 1);
  const addOnClientFull = extraClient * clientUnitCost * (isAnnual ? 12 : 1);

  // 20% discount on add-on staff and clients
  const addOnDiscountRate = 0.20;
  const addOnStaffPrice = addOnStaffFull * (1 - addOnDiscountRate);
  const addOnClientPrice = addOnClientFull * (1 - addOnDiscountRate);

  // Subtotal = Plan price + add-on price
  // const basePlanPrice = Number((planResponse ?? taxDetails)?.subtotal || 0);
  const basePlanPrice = Number(selectedPkg?.cost)
  const subtotalBeforeDiscount = basePlanPrice + addOnStaffPrice + addOnClientPrice;

  // Calculate discount amount
  const discountAmount = appliedDiscount
    ? appliedDiscount.discountType === "percentage"
      ? Math.min(subtotalBeforeDiscount, (subtotalBeforeDiscount * appliedDiscount.discountValue) / 100)
      : Math.min(subtotalBeforeDiscount, appliedDiscount.discountValue)
    : 0;

  const totalPrice = Math.max(0, subtotalBeforeDiscount - discountAmount);

  // Tax = % of Subtotal (including add-ons, post-discount)
  const taxPercentage = Number(
    (planResponse ?? taxDetails)?.taxPercentage || 0
  );
  const calculatedTaxAmount = (totalPrice * taxPercentage) / 100;

  const totalPriceWithTax = totalPrice + calculatedTaxAmount;

  useEffect(() => {
    setAdditionalClientValue(minimumClients);
    setAdditionalStaffValue(minimumStaff);
    setAppliedDiscount(null);
    setCouponCodeValue("");
    setCouponMsg("");
  }, [selectedPkg]);

  const handleSelectPkg = async (pkg, type) => {
    setLoadingCalculation(true);
    setSelectedPkg(pkg);
    const resp = await selectPlan({ id: pkg?.id, billingType: type });
    if (resp?.status === 200) {
      setPlanResponse(resp?.data?.taxDetails);
      setLoadingCalculation(false);
    }
  };
  const card = connected?.find((v) => v?.creditCard);

  const form = useForm({
    initialValues: {
      // nameCard: "",
      // cardNumber: "",
      // cardExp: "",
      // CVV: "",
      nameCard: "",
      cardNumber: "",
      cardExp: null,
      cardMonth: null,
      cardYear: null,
      CVV: "",
    },
    validate: {
      nameCard: (value) => (value ? null : "Please add card name"),
      cardNumber: (value) =>
        value && value?.length <= 16 ? null : "Please add a valid card number",
      // cardExp: (value) => (value ? null : "Select expiry date"),
      cardMonth: (value) => {
        const isValidLength = value && value.length === 2;
        return isValidLength ? null : "Please add a valid month";
      },
      cardYear: (value) => {
        const isValidLength = value && value.length === 2;
        return isValidLength ? null : "Please add a valid year";
      },
      CVV: (value) => {
        const isValidLength =
          value && (value?.length === 3 || value?.length === 4);
        return isValidLength ? null : "Please add a valid number";
      },
    },
  });

  const config = {
    onSuccess: async (public_token, metadata) => {
      let bankData = await exchangeToken({ publicToken: public_token });
      if (bankData) {
        if (newConnect === "true") return navigate("/home/settings");
        getAllConnected();
      }
    },
    onExit: (err, metadata) => {},
    onEvent: (eventName, metadata) => {
      if (eventName.includes("EXIT")) {
        setLoading(false);
      }
    },
    token: sessionLink,
  };
  const { open, exit, ready } = usePlaidLink(config);

  useEffect(() => {
    if (getCookie("token") && profile) {
      socket.emit("join", profile?.user.id);
      setInstance(socket);
    }
  }, [getCookie("token")]);

  useEffect(() => {
    socket.on("reconnect", () => {
      if (profile?.user) {
        socket.emit("join", profile?.user?.id);
      }
    });

    socket.on("payment-update", (status) => {
      if (status === "payment succeeded") {
        setConnectingCard(false);
        setPaymentDeductionLoading(false);
        setPaymentDeduction(false);
        getProfile();
        if (!location.pathname.includes("home/settings"))
          // swal("Subscription Completed!", {
          //   icon: "success",
          //   buttons: {
          //     // ok: "Proceed to Dashboard"
          //     ok: {
          //       text: "Proceed to Dashboard",
          //       value: "dashboard", // Assign a unique value to identify the button
          //     },
          //   },
          // }
          navigate("/payment-success");
        else
          swal("Account changed Successfully", {
            icon: "success",
            buttons: {
              ok: "Ok",
            },
          });
      } else if (status?.code === "payment failed") {
        setConnectingCard(false);

        swal("Payment Failed", {
          icon: "error",
          text: `${status?.message}\nPlease ensure your card has enough balance.`,
          buttons: {
            ok: {
              text: "Go Back",
              value: "dashboard",
            },
          },
        }).then((value) => {
          switch (value) {
            case "dashboard":
              removeCookie("token");
              navigate("/");
            default:
              navigate("/home");
          }
        });
      } else {
        setConnectingCard(false);

        setPaymentDeductionLoading(false);
        setPaymentDeductionFeedback(status);
      }
    });
  }, []);

  useEffect(() => {
    // getLink();
    getAllConnected();
    pageInfoAnalytics("Payment Page Viewed", "Payment Page");
  }, []);

  useEffect(() => {
    if (ready) {
      setLoading(false);
    }
  }, [ready, sessionLink]);

  useEffect(() => {
    if (form.getInputProps("cardNumber")?.value?.length > 16) {
      form.setFieldValue(
        "cardNumber",
        form.getInputProps("cardNumber")?.value?.slice(0, 16)
      );
    }
  }, [form.getInputProps("cardNumber")?.value]);

  useEffect(() => {
    if (form.getInputProps("CVV")?.value?.length > 4) {
      form.setFieldValue("CVV", form.getInputProps("CVV")?.value?.slice(0, 4));
    }
  }, [form.getInputProps("CVV")?.value]);

  useEffect(() => {
    if (form.getInputProps("cardMonth")?.value?.length > 2) {
      form.setFieldValue(
        "cardMonth",
        form.getInputProps("cardMonth")?.value?.slice(0, 2)
      );
    }
  }, [form.getInputProps("cardMonth")]);

  useEffect(() => {
    if (form.getInputProps("cardYear")?.value?.length > 2) {
      form.setFieldValue(
        "cardYear",
        form.getInputProps("cardYear")?.value?.slice(0, 2)
      );
    }
  }, [form.getInputProps("cardYear")]);

  const getAllConnected = async () => {
    let accounts = await getConnectedAccounts();
    const activeAccounts = accounts.filter((account) => account.isActive);
    setConnected(activeAccounts);
    setConnectedLoading(false);
  };

  const getLink = async () => {
    let data = await getPlaidLink();
    setSessionLink(data?.link_token);
  };

  const buildSubscriptionPayload = (paymentMethod) => {
    let obj = {
      packageId: selectedPkg?.id,
      stripePlanId: selectedPkg?.stripeId,
      email: profile?.user?.email,
      userId: profile?.user.id,
      businessId: profile?.business?.id,
      stripeCustomerId: paymentMethod?.stripeCustomerId,
      susbcriptionType: selectedPkg?.duration,
      taxDetails: taxDetails,
      calculatedTaxAmount: calculatedTaxAmount.toFixed(2),
      totalPriceWithTax: totalPriceWithTax.toFixed(2),
    };

    // Attach discount code if applied
    if (appliedDiscount) {
      obj.discountCode = {
        id: appliedDiscount.id,
        code: appliedDiscount.code,
        discountType: appliedDiscount.discountType,
        discountValue: appliedDiscount.discountValue,
        durationMonths: appliedDiscount.durationMonths,
      };
      obj.discountAmount = discountAmount.toFixed(2);
    }

    if (
      Number(item?.staff) !== additionalStaffValue ||
      Number(item?.patient) !== additionalClientValue
    ) {
      return {
        ...obj,
        isUserChangeAdditionalCount: true,
        customStaffCount: String(additionalStaffValue),
        customPatientCount: String(additionalClientValue),
        addOnClientPrice: String(addOnClientPrice.toFixed(2)),
        addOnStaffPrice: String(addOnStaffPrice.toFixed(2)),
        total: planResponse?.subtotal
          ? planResponse.subtotal
          : totalPrice.toFixed(2),
      };
    }

    return obj;
  };

  const onFinish = async (values) => {
    const { cardMonth, cardYear } = values;
    let obj = {
      ...values,
      packageId: selectedPkg?.id,
      stripePlanId: selectedPkg?.stripeId,
      email: profile?.user?.email,
      userId: profile?.user.id,
      businessId: profile?.business?.id,
      cardExp: `${cardMonth}/${cardYear}`,
    };

    delete obj?.cardMonth;
    delete obj?.cardYear;

    setConnectingCard(true);
    try {
      let accounts = await getConnectedAccounts();
      const onSuccessPayment = async (stripeCustomerId) => {
        const payload = buildSubscriptionPayload({ stripeCustomerId });
        const resp = await createSubscription(payload, null, "automatic");
        if (resp?.status === 200) {
          setPlanResponse("");
          setPaymentDeduction(true);
          setPaymentDeductionLoading(true);
          // setConnectingCard(false);
        } else {
          setConnectingCard(false);
          showError(resp || "Something went wrong", 500);
        }
      };
      if (accounts?.length > 0) {
        // updateCard(obj, async (error, data) => {
        //   if (!error) {
        //     // setPlanResponse("");
        //     await onSuccessPayment(data?.stripeCustomer?.id);
        //     // setConnectingCard(false);
        //     if (newConnect === "true") return navigate("/home/settings");
        //     getAllConnected();
        //   } else {
        //     setConnectingCard(false);
        //   }
        // });
        updateCard(obj, async (error, data) => {
          if (error) {
            setConnectingCard(false);
            swal(
              "Payment failed. Please try another card.",
              `${error || "Something went wrong"}`,
              "error"
            );
            // setPaymentError(true);
            return;
          }

          // success
          await onSuccessPayment(data?.stripeCustomer?.id);

          if (newConnect === "true") {
            navigate("/home/settings");
            return;
          }

          getAllConnected();
        });
      } else {
        connectCard(obj, async (error, data) => {
          if (error) {
            setConnectingCard(false);
            swal(
              "Payment failed. Please try another card.",
              `${error || "Something went wrong"}`,
              "error"
            );
            // setPaymentError(true);
            return;
          }

          // success
          await onSuccessPayment(data?.stripeCustomer?.id);

          if (newConnect === "true") {
            navigate("/home/settings");
            return;
          }

          getAllConnected();
        });
        // if (!error) {
        //   // setPlanResponse("");
        //   await onSuccessPayment(data?.stripeCustomer?.id);
        //   // setConnectingCard(false);
        //   if (newConnect === "true") return navigate("/home/settings");
        //   getAllConnected();
        // } else {
        //   setConnectingCard(false);
        // }
      }
    } catch (error) {
      setConnectingCard(false);
      // setConnectingCard(false);
    }
  };
  const onBack = () => {
    navigate("/selectprice");
    setPlanResponse("");
  };

  const start = () => {
    open();
    setLoading(true);
  };
  const removeAccount = async (paymentMethod) => {
    if (!paymentMethod?.isActive) {
      // setDeleteAccountLoading(true);
      let response = await deleteCustomer(paymentMethod?.stripeCustomerId);
      if (response) {
        getAllConnected();
        // setDeleteAccountLoading(false);
        setPaymentLoading(false);
      }
    } else {
      swal({
        title: "Remove Account",
        text: "Cannot remove account, this account is being used.",
        icon: "warning",
      });
    }
  };

  // const payNow = async (paymentMethod) => {
  //   setPaymentLoading(true);
  //   let payload = {};
  //   let obj = {
  //     packageId: selectedPkg?.id,
  //     stripePlanId: selectedPkg?.stripeId,
  //     email: profile?.user?.email,
  //     userId: profile?.user.id,
  //     businessId: profile?.business?.id,
  //     stripeCustomerId: paymentMethod?.stripeCustomerId,
  //     susbcriptionType: selectedPkg?.duration,
  //   };
  //   if (
  //     Number(item?.staff) !== additionalStaffValue ||
  //     Number(item?.patient) !== additionalClientValue
  //   ) {
  //     payload = {
  //       ...obj,
  //       isUserChangeAdditionalCount: true,
  //       customStaffCount: String(additionalStaffValue),
  //       customPatientCount: String(additionalClientValue),
  //       total: planResponse?.subtotal
  //         ? planResponse.subtotal
  //         : totalPrice.toFixed(2),
  //     };
  //   } else {
  //     payload = obj;
  //   }
  //   const resp = await createSubscription(payload, null, "automatic");
  //   if (resp?.status === 200) {
  //     setPlanResponse("");
  //     setPaymentLoading(false);
  //     setPaymentDeduction(true);
  //     setPaymentDeductionLoading(true);
  //   }
  // };
  // const names = {
  //   Personal: "Silver",
  //   Agency: "Gold",
  //   Trial: "Trial",
  // };

  // const totalPrice =
  //   (Number(planResponse?.subtotal || 0) ?? Number(taxDetails?.subtotal || 0)) +
  //   addOnStaffPrice +
  //   addOnClientPrice;

  // const totalPrice =
  //   Number((planResponse ?? taxDetails)?.subtotal || 0) +
  //   addOnStaffPrice +
  //   addOnClientPrice;

  // const totalPriceWithTax =
  //   (planResponse
  //     ? Number(planResponse.subtotal || 0) + Number(planResponse.taxAmount || 0)
  //     : Number(taxDetails?.subtotal || 0) +
  //       Number(taxDetails?.taxAmount || 0)) +
  //   addOnStaffPrice +
  //   addOnClientPrice;

  // const totalPriceWithTax =
  //   (Number(planResponse?.subtotal || 0) ?? Number(taxDetails?.subtotal || 0)) +
  //   addOnStaffPrice +
  //   addOnClientPrice +
  //   (Number(planResponse?.taxAmount) ?? Number(taxDetails?.taxAmount));

  // const handleAddOn = async () => {
  //   setLoadingCalculation(true);
  //   const resp = await calTaxCustomPlan({
  //     total: totalPrice.toFixed(2),
  //     addOnStaffPrice: addOnStaffPrice,
  //     addOnClientPrice: addOnClientPrice,
  //   });
  //   if (resp?.status === 200) {
  //     setCalTaxAddOn(resp?.data?.taxDetails);
  //     setLoadingCalculation(false);
  //   }
  // };
  return (
    <div className="payment-page">
      {/* <Container size={"sm"}> */}
      {/* <Radio.Group value={value} onChange={setValue} size="md" name="paytype">
          <SimpleGrid cols={2} spacing={10}>
            <Radio
              className={
                value === "automatic" ? classes.selected : classes.type
              }
              value="automatic"
              size="md"
              color="yellow"
              label={
                <>
                  <Text className={classes.font1}> Automatic</Text>{" "}
                  <Text className={classes.font2}>
                    Connect to bank with plaid
                  </Text>
                </>
              }
            />
            <Radio
              className={value === "manual" ? classes.selected : classes.type}
              size="md"
              color="yellow"
              value="manual"
              label={
                <>
                  <Text className={classes.font1}>Manual</Text>{" "}
                  <Text className={classes.font2}>
                    Enter card Details Manually
                  </Text>
                </>
              }
            />
          </SimpleGrid>
        </Radio.Group> */}
      {/* </Container> */}

      {/* plaid link component */}
      {/* {value === "automatic" && (
        <>
          {!isFreeAccount && (
            <Group className={classes.back}>
              <ActionIcon
                variant="outline"
                size={"xl"}
                radius={"xl"}
                onClick={onBack}
              >
                <IconChevronLeft />
              </ActionIcon>
              <Text>Back</Text>
            </Group>
          )}
          <Container className={classes.centered} size={"sm"}>
            <div className={classes.logo}>
              <img width={"30%"} src="assets/images/logo2.png" alt="" />
            </div>
            <Text className={classes.title}>Payment Information</Text>
          </Container>
          <center style={{ marginTop: "50px" }}>
            <Flex
              mih={50}
              gap="md"
              justify="flex-start"
              direction="row"
              wrap="wrap"
              className={classes.plaidComponent}
            >
              <img
                className={classes.connectBankImage}
                src="assets/images/bank.png"
                alt=""
              />
              <Flex
                direction="column"
                align={"flex-start"}
                className={classes.insideFlex}
              >
                {connectedLoading ? (
                  <>
                    <Skeleton
                      height={50}
                      width={100}
                      radius="sm"
                      style={{ marginTop: "10px" }}
                    />
                    <Skeleton
                      height={50}
                      radius="sm"
                      style={{ marginTop: "10px" }}
                    />
                  </>
                ) : connected?.filter((v) => !v?.creditCard)?.length ? (
                  paymentDeduction ? (
                    <div>
                      <Flex direction="row" align={"center"} gap={10}>
                        {paymentDeductionLoading && (
                          <Loader color="yellow" size={"sm"} />
                        )}
                        <Text
                          my={10}
                          style={{
                            fontWeight: "600",
                            textAlign: "start",
                          }}
                          color={"yellow"}
                        >
                          {paymentDeductionFeedback
                            ? ""
                            : "Processing Payment ..."}
                        </Text>
                      </Flex>
                      <Text
                        my={10}
                        style={{
                          fontWeight: "600",
                          textAlign: "start",
                          opacity: 0.3,
                        }}
                      >
                        {paymentDeductionFeedback
                          ? paymentDeductionFeedback
                          : "Please wait we are tranfering funds..."}
                      </Text>
                    </div>
                  ) : (
                    <div>
                      <Text
                        my={10}
                        style={{
                          fontWeight: "600",
                          textAlign: "start",
                        }}
                        color="green"
                      >
                        Connected Bank Account
                      </Text>

                      <p
                        style={{
                          textAlign: "start",
                          fontWeight: "bold",
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        {selectedPkg?.name}{" "}
                        {newConnect != "true" ? `($${selectedPkg?.cost})` : ""}
                      </p>
                      <p
                        style={{
                          color: "#A8A8A8",
                          textAlign: "start",
                        }}
                      >
                        {string}
                      </p>

                      {newConnect != "true" &&
                        !connected?.find((v) => !v?.creditCard)?.isActive && (
                          <Flex direction="row" gap={20}>
                            <Button
                              color="yellow"
                              onClick={() =>
                                payNow(connected?.find((v) => !v?.creditCard))
                              }
                              loading={paymentLoading}
                            >
                              Subscribe Now
                            </Button>

                          </Flex>
                        )}
                    </div>
                  )
                ) : (
                  <div>
                    <Text
                      my={10}
                      style={{ fontWeight: "600", textAlign: "start" }}
                    >
                      Connect Bank Account
                    </Text>
                    <Text variant="text" style={{ textAlign: "start" }}>
                      Link your bank account for smooth transaction.
                    </Text>

                    <p
                      style={{
                        textAlign: "start",
                        fontWeight: "bold",
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      {selectedPkg?.name}{" "}
                      {newConnect != "true" ? `($${selectedPkg?.cost})` : ""}
                    </p>
                    <p
                      style={{
                        color: "#A8A8A8",
                        textAlign: "start",
                        margin: 0,
                      }}
                    >
                      <br />
                      {string}
                    </p>
                    <Flex justify={"flex-start"} my={10}>
                      <Button color="yellow" onClick={start} loading={loading}>
                        Connect
                      </Button>
                    </Flex>
                  </div>
                )}
              </Flex>
            </Flex>
          </center>
        </>
      )} */}
      {/* {value === "manual" && ( */}
      <>
        {connectedLoading ? (
          <>
            {/* {!isFreeAccount && (
              <Group className={classes.back}>
                <ActionIcon
                  variant="outline"
                  size={"xl"}
                  radius={"xl"}
                  onClick={onBack}
                >
                  <IconChevronLeft />
                </ActionIcon>
                <Text>Back</Text>
              </Group>
            )} */}
            {/* <Container className={classes.centered} mih={"100vh"} size={"sm"}> */}
            {/* <div className={classes.logo}>
                  <img width={"30%"} src="assets/images/logo2.png" alt="" />
                </div>
                <Text className={classes.title}>Payment Information</Text> */}
            <Center w="100%" mih="100vh">
              <Loader color="yellow" />
            </Center>
            {/* </Container> */}
          </>
        ) : (
          // ) : connected?.filter((v) => v?.creditCard)?.length ? (
          //   <>
          //     {!isFreeAccount && (
          //       <Group className={classes.back}>
          //         <ActionIcon
          //           variant="outline"
          //           size={"xl"}
          //           radius={"xl"}
          //           onClick={onBack}
          //         >
          //           <IconChevronLeft />
          //         </ActionIcon>
          //         <Text>Back</Text>
          //       </Group>
          //     )}
          //     <Container className={classes.centered} size={"sm"}>
          //       <div className={classes.logo}>
          //         <img width={"30%"} src="assets/images/logo2.png" alt="" />
          //       </div>
          //       <Text className={classes.title}>Payment Information  /////</Text>
          //     </Container>
          //     <Container size={"md"}>
          //       <Card shadow="sm" className={classes.card}>
          //         <Flex
          //           // mih={50}s
          //           gap="md"
          //           justify="flex-start"
          //           direction="row"
          //           wrap="wrap"
          //           // className={classes.plaidComponent}
          //         >
          //           <img
          //             className={classes.connectBankImage}
          //             src="assets/images/bank.png"
          //             alt=""
          //           />
          //           {paymentDeduction ? (
          //             <div>
          //               <Flex direction="row" align={"center"} gap={10}>
          //                 {paymentDeductionLoading && (
          //                   <Loader color="yellow" size={"sm"} />
          //                 )}
          //                 <Text
          //                   my={10}
          //                   style={{
          //                     fontWeight: "600",
          //                     textAlign: "start",
          //                   }}
          //                   color={"yellow"}
          //                 >
          //                   {paymentDeductionFeedback
          //                     ? ""
          //                     : "Processing Payment ..."}
          //                 </Text>
          //               </Flex>
          //               <Text
          //                 my={10}
          //                 style={{
          //                   fontWeight: "600",
          //                   textAlign: "start",
          //                   opacity: 0.3,
          //                 }}
          //               >
          //                 {paymentDeductionFeedback
          //                   ? paymentDeductionFeedback
          //                   : "Please wait we are tranfering funds..."}
          //               </Text>
          //             </div>
          //           ) : (
          //             <div>
          //               <Text
          //                 my={10}
          //                 style={{
          //                   fontWeight: "600",
          //                   textAlign: "start",
          //                 }}
          //                 color="green"
          //               >
          //                 Connected Card
          //               </Text>
          //               <p style={{ color: "#A8A8A8", textAlign: "start" }}>
          //                 Details
          //               </p>
          //               <table>
          //                 <tr>
          //                   <td>Account Name: </td>
          //                   <td>{card?.cardName}</td>
          //                 </tr>
          //                 <tr>
          //                   <td> Card Number : </td>
          //                   <td>{card?.cardNumber}</td>
          //                 </tr>
          //               </table>
          //               {newConnect !== "true" &&
          //                 !connected?.filter((v) => v?.creditCard)
          //                   ?.isActive && (
          //                   <Flex mt={30} direction="row" gap={20}>
          //                     <Button
          //                       color="yellow"
          //                       onClick={() =>
          //                         payNow(connected?.find((v) => v?.creditCard))
          //                       }
          //                       loading={paymentLoading}
          //                     >
          //                       Subscribe Now
          //                     </Button>
          //                     <Button
          //                       color="yellow"
          //                       onClick={() => {
          //                         setConnected([]);
          //                         setUpdatecard(true);

          //                         // newConnect='true'
          //                       }}

          //                       // loading={paymentLoading}
          //                     >
          //                       Update Card
          //                     </Button>

          //                     {/* <Button
          //                   variant="outline"
          //                   color="yellow"
          //                   loading={deleteAccountLoading}
          //                   onClick={() =>
          //                     removeAccount(
          //                       connected?.find((v) => v?.creditCard)
          //                     )
          //                   }
          //                 >
          //                   Remove
          //                 </Button> */}
          //                   </Flex>
          //                 )}
          //             </div>
          //           )}
          //         </Flex>
          //       </Card>
          //     </Container>
          //   </>
          // )
          <Flex className={classes.paymentPageBox}>
            <Box className={classes.paymentPageBoxLeft}>
              <Box className={classes.paymentPageBoxLeftInner}>
                {!isFreeAccount && (
                  <UnstyledButton
                    onClick={onBack}
                    className={classes.paymentPageBoxBackBtn}
                  >
                    <IconChevronLeft />
                    Back
                  </UnstyledButton>
                )}
                <img
                  src="assets/images/logo2.png"
                  alt=""
                  className={classes.paymentPageBoxLogo}
                />
                <Box className={classes.paymentLeftContent}>
                  <h5 className="hdng">Payment Summary</h5>
                  <p className="subHdng">
                    Get {yearlyPlan ? yearlyPlan?.promotion : ""}% off when you
                    subscribe annually
                  </p>
                  <p className="trialPkgNameText">
                    {isTrialNotUsed && selectedPkg?.duration === "month" ? (
                      <>
                        <p className="trialText">2 Weeks free trial</p>&nbsp;(
                        {selectedPkg?.name} Plan)
                      </>
                    ) : (
                      `(${selectedPkg?.name} Plan)`
                    )}
                  </p>
                  {monthlyPlan && (
                    <Flex
                      className={`${classes.pkgSelectBox} ${
                        selectedPkg?.id === monthlyPlan?.id
                          ? classes.selectedPkgSelectBox
                          : ""
                      }`}
                      onClick={() => handleSelectPkg(monthlyPlan, "month")}
                    >
                      <Radio
                        icon={CheckIcon}
                        className="radioBtn"
                        checked={selectedPkg?.id === monthlyPlan?.id}
                      />
                      <Box className="pkgInfo">
                        <p className="pkgDurationText">Monthly</p>
                        <p className="pkgPrice">
                          ${monthlyPlan?.cost} / {monthlyPlan?.duration}
                          <span className="staffAndClientCount">
                            ({monthlyPlan?.staff} Staff,
                            {monthlyPlan?.patient} Clients)
                          </span>
                        </p>
                      </Box>
                    </Flex>
                  )}
                  {yearlyPlan && (
                    <Flex
                      className={`${classes.pkgSelectBox} ${
                        selectedPkg?.id === yearlyPlan?.id
                          ? classes.selectedPkgSelectBox
                          : ""
                      }`}
                      onClick={() => handleSelectPkg(yearlyPlan, "year")}
                    >
                      <Radio
                        icon={CheckIcon}
                        className="radioBtn"
                        checked={selectedPkg?.id === yearlyPlan?.id}
                      />
                      <Box className="pkgInfo">
                        <p className="pkgDurationText">Annual</p>
                        <p className="pkgPrice">
                          ${yearlyPlan?.cost} / {yearlyPlan?.duration}
                          <span className="staffAndClientCount">
                            ({yearlyPlan?.staff} Staff, {yearlyPlan?.patient}{" "}
                            Clients)
                          </span>
                        </p>
                      </Box>
                      <p className="savePer">Save {yearlyPlan?.promotion}%</p>
                    </Flex>
                  )}
                  {item?.name !== "Starter" && (
                    <>
                      <p className={classes.staffAndClientAddSecHdng}>
                        Subscription Add-on
                      </p>
                      <p className={classes.staffAndClientAddSecSubHdng}>
                        Get 20% off if you add more Staff or Clients to your
                        subscription
                      </p>
                      <Box className={classes.staffAndClientCountBox}>
                        <NumberInput
                          className={classes.outcomeNumberInput}
                          label="Staff"
                          type="number"
                          min={minimumStaff}
                          variant="filled"
                          value={additionalStaffValue}
                          onChange={(value) => {
                            setAdditionalStaffValue(value || minimumStaff);
                          }}
                          icon={
                            <ActionIcon
                              className={classes.inc_dec_Btn}
                              size="xs"
                              onClick={() =>
                                setAdditionalStaffValue((prev) =>
                                  Math.max(minimumStaff, prev - 1)
                                )
                              }
                            >
                              <FaMinus size={15} color="#000" />
                            </ActionIcon>
                          }
                          rightSection={
                            <ActionIcon
                              className={classes.inc_dec_Btn}
                              size="xs"
                              onClick={() =>
                                setAdditionalStaffValue((prev) => prev + 1)
                              }
                            >
                              <FaPlus size={15} color="#000" />
                            </ActionIcon>
                          }
                        />
                        <NumberInput
                          className={classes.outcomeNumberInput}
                          label="Client"
                          type="number"
                          min={minimumClients}
                          variant="filled"
                          value={additionalClientValue}
                          onChange={(value) => {
                            setAdditionalClientValue(value || minimumClients);
                          }}
                          icon={
                            <ActionIcon
                              className={classes.inc_dec_Btn}
                              size="xs"
                              onClick={() =>
                                setAdditionalClientValue((prev) =>
                                  Math.max(minimumClients, prev - 1)
                                )
                              }
                            >
                              <FaMinus size={15} color="#000" />
                            </ActionIcon>
                          }
                          rightSection={
                            <ActionIcon
                              className={classes.inc_dec_Btn}
                              size="xs"
                              onClick={() =>
                                setAdditionalClientValue((prev) => prev + 1)
                              }
                            >
                              <FaPlus size={15} color="#000" />
                            </ActionIcon>
                          }
                        />
                      </Box>
                    </>
                  )}

                  {/* <Button
                      className={[
                        classes.paymentBtn,
                        classes.couponCodeSubmitBtn,
                      ]}
                      onClick={() => handleAddOn()}
                    >
                      Add On
                    </Button> */}

                  <Flex gap={15} my={20}>
                    <Box className={classes.couponCodeInput}>
                      <TextInput
                        placeholder="Discount Code"
                        className={classes.paymentInputFieldStyle}
                        value={couponCodeValue}
                        disabled={!!appliedDiscount}
                        onChange={(e) => {
                          setCouponCodeValue(e.target.value);
                          setCouponMsg("");
                        }}
                      />
                      {couponMsg && (
                        <p
                          className={classes.validationErrorMsg}
                          style={{
                            color: appliedDiscount ? "green" : "red",
                          }}
                        >
                          {couponMsg}
                        </p>
                      )}
                    </Box>
                    {appliedDiscount ? (
                      <Button
                        className={[
                          classes.paymentBtn,
                          classes.couponCodeSubmitBtn,
                        ]}
                        color="red"
                        variant="outline"
                        onClick={() => {
                          setAppliedDiscount(null);
                          setCouponCodeValue("");
                          setCouponMsg("");
                        }}
                      >
                        Remove
                      </Button>
                    ) : (
                      <Button
                        className={[
                          classes.paymentBtn,
                          classes.couponCodeSubmitBtn,
                        ]}
                        disabled={!couponCodeValue?.trim() || couponLoading}
                        loading={couponLoading}
                        onClick={async () => {
                          setCouponLoading(true);
                          try {
                            const result = await validateDiscountCode({
                              code: couponCodeValue.trim(),
                              planId: selectedPkg?.id,
                              userId: profile?.user?.id,
                            });
                            if (result?.valid) {
                              setAppliedDiscount(result.discountCode);
                              setCouponMsg(
                                result.discountCode.discountType === "percentage"
                                  ? `${result.discountCode.discountValue}% discount applied!`
                                  : `$${result.discountCode.discountValue} discount applied!`
                              );
                            } else {
                              setCouponMsg(result?.reason || "Invalid Code");
                              setAppliedDiscount(null);
                            }
                          } catch {
                            setCouponMsg("Failed to validate code");
                            setAppliedDiscount(null);
                          }
                          setCouponLoading(false);
                        }}
                      >
                        Apply
                      </Button>
                    )}
                  </Flex>
                  {loadingCalculation ? (
                    <Flex justify="center" align="center" my={50}>
                      <Loader color="yellow" />
                    </Flex>
                  ) : (
                    <Box>
                      <Flex className={classes.paymentPriceRow}>
                        <p>Discount Applied</p>
                        <Flex direction="column" align="flex-end" gap={10}>
                          <p style={appliedDiscount ? { color: "green", fontWeight: 600 } : {}}>
                            -${discountAmount.toFixed(2)}
                          </p>
                          {isTrialNotUsed && selectedPkg?.duration === "month" && (
                            <p className="trialText">Free Trial</p>
                          )}
                        </Flex>
                      </Flex>
                      <Divider mt={24} mb={24} />
                      <Flex className={classes.paymentPriceRow}>
                        <p>Subscription Plan</p>
                        <p>
                          ${selectedPkg?.cost}
                          {/* {planResponse?.subtotal
                            ? planResponse?.subtotal
                            : taxDetails?.subtotal} */}
                        </p>
                      </Flex>
                      {item?.name !== "Starter" && (
                        <>
                          <Flex className={classes.paymentPriceRow}>
                            <p>Add-on Staff</p>
                            <p>
                              {addOnStaffFull > 0 && addOnStaffFull !== addOnStaffPrice && (
                                <span style={{ textDecoration: "line-through", color: "#868e96", marginRight: 6, fontSize: "12px" }}>
                                  ${addOnStaffFull.toFixed(2)}
                                </span>
                              )}
                              ${addOnStaffPrice.toFixed(2)}
                            </p>
                          </Flex>
                          <Flex className={classes.paymentPriceRow}>
                            <p>Add-on Client</p>
                            <p>
                              {addOnClientFull > 0 && addOnClientFull !== addOnClientPrice && (
                                <span style={{ textDecoration: "line-through", color: "#868e96", marginRight: 6, fontSize: "12px" }}>
                                  ${addOnClientFull.toFixed(2)}
                                </span>
                              )}
                              ${addOnClientPrice.toFixed(2)}
                            </p>
                          </Flex>
                        </>
                      )}
                      {/* <Flex className={classes.paymentPriceRow}>
                        <p>Tax</p>
                        <p>
                          ${calculatedTaxAmount.toFixed(2)}
                        </p>
                      </Flex> */}
                      <Divider mt={16} mb={16} />

                      {/* Due Today + After Trial */}
                      <Flex direction="column" align="flex-end">
                        {/* Due Today */}
                        <Flex justify="space-between" w="100%">
                          <Text style={{ fontSize: "14px", fontWeight: 500 }}>
                            Due today
                          </Text>
                          <Text style={{ fontSize: "14px", fontWeight: 600 }}>
                            $
                            {isTrialNotUsed && selectedPkg?.duration === "month"
                              ? "0.00"
                              : totalPriceWithTax.toFixed(2)}
                          </Text>
                        </Flex>

                        {/* Amount after trial */}
                        {isTrialNotUsed && selectedPkg?.duration === "month" && (
                          <Flex direction="column" align="flex-end" mt={6}>
                            <p style={{ fontSize: "12px", color: "#868e96" }}>
                              Amount due after trial
                            </p>
                            <p style={{ fontSize: "13px", fontWeight: 600 }}>
                              ${totalPriceWithTax.toFixed(2)}
                            </p>
                          </Flex>
                        )}
                      </Flex>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
            <Box className={classes.paymentPageBoxRight}>
              <form onSubmit={form.onSubmit((values) => onFinish(values))}>
                <h4>
                  <CiCreditCard1 size={34} />
                  Credit or Debit Card
                </h4>
                <div className={classes.inputs}>
                  <TextInput
                    variant="filled"
                    id="name-on-card"
                    label="Name on Card"
                    size="lg"
                    type=""
                    autoComplete="cc-name"
                    placeholder="Eg.abc"
                    {...form.getInputProps("nameCard")}
                    className={classes.paymentInputFieldStyle}
                  />
                </div>

                <div className={classes.inputs}>
                  <TextInput
                    variant="filled"
                    id="card-number"
                    label="Card Number"
                    size="lg"
                    type="number"
                    placeholder="Eg.5952 **** **** ****"
                    {...form.getInputProps("cardNumber")}
                    className={classes.paymentInputFieldStyle}
                  />
                  {/* {paymentError && (
                    <Text color="red" size="md" mt={5} ff={"Inter"} fw={500} >
                      Payment failed. Please try another card.
                    </Text>
                  )} */}
                  {form.errors.cardNumber && (
                    <div style={{ color: "red" }}>
                      {form.errors.cardNumber.message}
                    </div>
                  )}
                </div>

                {/* <SimpleGrid cols={2} className={classes.m10}>
                  <DateInput
                    variant="filled"
                    id="expiry-date"
                    label="Expiry Date"
                    valueFormat="MM/YY"
                    size="lg"
                    minDate={new Date()}
                    placeholder="Eg.08/23"
                    {...form.getInputProps("cardExp")}
                    className={classes.myfont}
                  />
                  <TextInput
                    variant="filled"
                    id="cvv"
                    label="CVV"
                    type="number"
                    size="lg"
                    placeholder="Eg.***"
                    {...form.getInputProps("CVV")}
                    className={classes.myfont}
                  />
                </SimpleGrid> */}

                <Grid align="flex-end">
                  <Grid.Col span={4}>
                    {/* ----- card month ----- */}
                    <TextInput
                      size="lg"
                      label="MM"
                      type="number"
                      variant="filled"
                      placeholder="MM"
                      className={classes.paymentInputFieldStyle}
                      {...form.getInputProps("cardMonth")}
                    />
                  </Grid.Col>
                  {/* ----- card year ----- */}
                  <Grid.Col span={4}>
                    <TextInput
                      size="lg"
                      label="YY"
                      type="number"
                      variant="filled"
                      placeholder="YY"
                      className={classes.paymentInputFieldStyle}
                      {...form.getInputProps("cardYear")}
                    />
                  </Grid.Col>
                  <Grid.Col span={4}>
                    <TextInput
                      size="lg"
                      label="CVV"
                      type="number"
                      variant="filled"
                      placeholder="Eg.***"
                      className={classes.paymentInputFieldStyle}
                      {...form.getInputProps("CVV")}
                    />
                  </Grid.Col>
                </Grid>

                <Button
                  id="submit-card"
                  type="submit"
                  loading={connectingCard}
                  className={classes.paymentBtn}
                >
                  {isTrialNotUsed && selectedPkg?.duration === "month" ? "Start Free Trial" : "Pay Now"}
                </Button>
                <p className={classes.agreeTermsCondText}>
                  By subscribing, you agree to our{" "}
                  <Link to="/term-conditions">terms and conditions</Link>.
                </p>
              </form>
            </Box>
          </Flex>
        )}
      </>
      {/* )} */}
    </div>
  );
};

export default PaymentInfoNew;
